var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 34,
    viewBox: "0 0 118 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.63 34H4.37037C1.96776 34 0 32.0864 0 29.75V4.25C0 1.91356 1.96776 1.43051e-06 4.37037 1.43051e-06H113.63C116.032 1.43051e-06 118 1.91356 118 4.25V29.75C118 32.0864 116.032 34 113.63 34Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.63 0.681063C115.653 0.681063 117.3 2.28225 117.3 4.25V29.75C117.3 31.7178 115.653 33.3189 113.63 33.3189H4.37037C2.34689 33.3189 0.700352 31.7178 0.700352 29.75V4.25C0.700352 2.28225 2.34689 0.681063 4.37037 0.681063H113.63ZM113.63 1.43051e-06H4.37037C1.96776 1.43051e-06 0 1.91356 0 4.25V29.75C0 32.0864 1.96776 34 4.37037 34H113.63C116.032 34 118 32.0864 118 29.75V4.25C118 1.91356 116.032 1.43051e-06 113.63 1.43051e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12117 6.40854C8.86441 6.66992 8.71582 7.07685 8.71582 7.60385V26.4016C8.71582 26.9286 8.86441 27.3355 9.12117 27.5969L9.18454 27.6543L20.0165 17.1249V16.8763L9.18454 6.34692L9.12117 6.40854Z",
    fill: "url(#paint0_linear_789_21167)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6232 20.6367L20.0166 17.1252V16.8765L23.6276 13.365L23.7085 13.4107L27.9849 15.7768C29.2053 16.4483 29.2053 17.5533 27.9849 18.2291L23.7085 20.591L23.6232 20.6367Z",
    fill: "url(#paint1_linear_789_21167)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7083 20.5906L20.0164 17.0004L9.12109 27.5967C9.52645 28.0111 10.1875 28.061 10.9392 27.6467L23.7083 20.5906Z",
    fill: "url(#paint2_linear_789_21167)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7083 13.4098L10.9392 6.35375C10.1875 5.94363 9.52645 5.99356 9.12109 6.40794L20.0164 17L23.7083 13.4098Z",
    fill: "url(#paint3_linear_789_21167)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4468 8.70787C41.4468 9.41762 41.2283 9.98606 40.7978 10.41C40.3028 10.9126 39.6582 11.1654 38.8683 11.1654C38.1133 11.1654 37.4686 10.9083 36.9398 10.4015C36.4099 9.88725 36.1455 9.25612 36.1455 8.50069C36.1455 7.74525 36.4099 7.11412 36.9398 6.60413C37.4686 6.09306 38.1133 5.83594 38.8683 5.83594C39.2441 5.83594 39.6025 5.91138 39.9445 6.05162C40.2853 6.19294 40.5629 6.38419 40.7639 6.62006L40.3072 7.06844C39.9565 6.66575 39.479 6.46706 38.8683 6.46706C38.3176 6.46706 37.8401 6.65406 37.4348 7.03125C37.0338 7.4095 36.8327 7.89931 36.8327 8.50069C36.8327 9.10206 37.0338 9.59612 37.4348 9.97437C37.8401 10.3473 38.3176 10.5386 38.8683 10.5386C39.4528 10.5386 39.9445 10.3473 40.3323 9.97012C40.588 9.72044 40.7333 9.37619 40.7715 8.93631H38.8683V8.32219H41.4074C41.438 8.455 41.4468 8.58356 41.4468 8.70787Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4754 6.57796H43.0903V8.19296H45.2405V8.80708H43.0903V10.4221H45.4754V11.0479H42.415V5.95215H45.4754V6.57796Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3179 11.0479H47.6427V6.57796H46.1797V5.95215H49.782V6.57796H48.3179V11.0479Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3887 11.0479V5.95215H53.0628V11.0479H52.3887Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0513 11.0479H55.3815V6.57796H53.9131V5.95215H57.5197V6.57796H56.0513V11.0479Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3401 10.393C63.8233 10.9083 63.183 11.1654 62.4193 11.1654C61.6512 11.1654 61.0109 10.9083 60.4941 10.393C59.9784 9.87875 59.7217 9.24762 59.7217 8.50069C59.7217 7.75375 59.9784 7.12262 60.4941 6.60837C61.0109 6.09306 61.6512 5.83594 62.4193 5.83594C63.1786 5.83594 63.8189 6.09306 64.3357 6.61262C64.8558 7.13112 65.1125 7.758 65.1125 8.50069C65.1125 9.24762 64.8558 9.87875 64.3401 10.393ZM60.9935 9.96587C61.3824 10.3473 61.8555 10.5386 62.4193 10.5386C62.9787 10.5386 63.4562 10.3473 63.8408 9.96587C64.2286 9.58444 64.4253 9.09462 64.4253 8.50069C64.4253 7.90675 64.2286 7.41694 63.8408 7.0355C63.4562 6.65406 62.9787 6.46281 62.4193 6.46281C61.8555 6.46281 61.3824 6.65406 60.9935 7.0355C60.6056 7.41694 60.4089 7.90675 60.4089 8.50069C60.4089 9.09462 60.6056 9.58444 60.9935 9.96587Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0596 11.0479V5.95215H66.879L69.4269 9.91527H69.4564L69.4269 8.93565V5.95215H70.1011V11.0479H69.3974L66.7293 6.88927H66.6998L66.7293 7.87315V11.0479H66.0596Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5551 18.4896C57.5021 18.4896 55.825 20.0089 55.825 22.1053C55.825 24.1846 57.5021 25.7199 59.5551 25.7199C61.6125 25.7199 63.2896 24.1846 63.2896 22.1053C63.2896 20.0089 61.6125 18.4896 59.5551 18.4896ZM59.5551 24.2961C58.4286 24.2961 57.4595 23.3919 57.4595 22.1053C57.4595 20.8016 58.4286 19.9133 59.5551 19.9133C60.6816 19.9133 61.6551 20.8016 61.6551 22.1053C61.6551 23.3919 60.6816 24.2961 59.5551 24.2961ZM51.4164 18.4896C49.359 18.4896 47.6863 20.0089 47.6863 22.1053C47.6863 24.1846 49.359 25.7199 51.4164 25.7199C53.4726 25.7199 55.1465 24.1846 55.1465 22.1053C55.1465 20.0089 53.4726 18.4896 51.4164 18.4896ZM51.4164 24.2961C50.2888 24.2961 49.3164 23.3919 49.3164 22.1053C49.3164 20.8016 50.2888 19.9133 51.4164 19.9133C52.5428 19.9133 53.512 20.8016 53.512 22.1053C53.512 23.3919 52.5428 24.2961 51.4164 24.2961ZM41.7316 19.5978V21.1341H45.5044C45.394 21.9926 45.099 22.6238 44.6467 23.0636C44.096 23.5949 43.2383 24.1846 41.7316 24.1846C39.4099 24.1846 37.5918 22.3624 37.5918 20.1046C37.5918 17.8468 39.4099 16.0246 41.7316 16.0246C42.987 16.0246 43.9004 16.5016 44.5746 17.12L45.6879 16.0373C44.745 15.1618 43.4907 14.4893 41.7316 14.4893C38.5478 14.4893 35.8721 17.0084 35.8721 20.1046C35.8721 23.2007 38.5478 25.7199 41.7316 25.7199C43.4525 25.7199 44.745 25.1716 45.7611 24.1431C46.8024 23.1306 47.1269 21.7068 47.1269 20.5572C47.1269 20.2002 47.0963 19.8719 47.0416 19.5978H41.7316ZM81.3337 20.7888C81.0267 19.9803 80.0794 18.4896 78.1499 18.4896C76.2379 18.4896 74.646 19.9548 74.646 22.1053C74.646 24.1304 76.2215 25.7199 78.3335 25.7199C80.0412 25.7199 81.0267 24.7073 81.4321 24.1176L80.1647 23.2963C79.7418 23.8977 79.166 24.2961 78.3335 24.2961C77.5064 24.2961 76.9131 23.9274 76.5329 23.2007L81.5053 21.2L81.3337 20.7888ZM76.2641 21.9926C76.2215 20.5986 77.3775 19.8846 78.2057 19.8846C78.8547 19.8846 79.4053 20.2002 79.5889 20.6518L76.2641 21.9926ZM72.2226 25.4999H73.8571V14.8749H72.2226V25.4999ZM69.5458 19.2949H69.4911C69.124 18.8721 68.4237 18.4896 67.5365 18.4896C65.6747 18.4896 63.9725 20.0791 63.9725 22.1169C63.9725 24.1431 65.6747 25.7199 67.5365 25.7199C68.4237 25.7199 69.124 25.3342 69.4911 24.8986H69.5458V25.4171C69.5458 26.7994 68.7864 27.5421 67.5616 27.5421C66.563 27.5421 65.9435 26.8408 65.6878 26.2511L64.2664 26.8281C64.6761 27.7864 65.761 28.9658 67.5616 28.9658C69.478 28.9658 71.0951 27.8693 71.0951 25.2014V18.7095H69.5458V19.2949ZM67.6763 24.2961C66.5499 24.2961 65.607 23.3792 65.607 22.1169C65.607 20.843 66.5499 19.9133 67.6763 19.9133C68.7864 19.9133 69.6616 20.843 69.6616 22.1169C69.6616 23.3792 68.7864 24.2961 67.6763 24.2961ZM88.9863 14.8749H85.077V25.4999H86.7071V21.4741H88.9863C90.7967 21.4741 92.5721 20.2002 92.5721 18.174C92.5721 16.1489 90.7923 14.8749 88.9863 14.8749ZM89.0289 19.9962H86.7071V16.3529H89.0289C90.246 16.3529 90.9409 17.3357 90.9409 18.174C90.9409 18.9964 90.246 19.9962 89.0289 19.9962ZM99.1058 18.4694C97.928 18.4694 96.7032 18.9751 96.1995 20.0961L97.6461 20.6858C97.9575 20.0961 98.5301 19.9048 99.1353 19.9048C99.981 19.9048 100.839 20.3989 100.852 21.2712V21.3828C100.557 21.217 99.9253 20.9716 99.1485 20.9716C97.5904 20.9716 96.0029 21.8056 96.0029 23.3622C96.0029 24.7859 97.279 25.7029 98.7136 25.7029C99.8106 25.7029 100.416 25.2216 100.796 24.6616H100.852V25.4829H102.426V21.4072C102.426 19.5234 100.98 18.4694 99.1058 18.4694ZM98.9092 24.2919C98.376 24.2919 97.633 24.0348 97.633 23.3919C97.633 22.5696 98.5596 22.254 99.3615 22.254C100.079 22.254 100.416 22.4081 100.852 22.611C100.724 23.5949 99.8532 24.2919 98.9092 24.2919ZM108.162 18.7021L106.289 23.308H106.233L104.296 18.7021H102.538L105.448 25.1387L103.788 28.7204H105.491L109.976 18.7021H108.162ZM93.4681 25.4999H95.1026V14.8749H93.4681V25.4999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_789_21167",
    x1: 19.0548,
    y1: 26.5974,
    x2: 4.79527,
    y2: 11.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_789_21167",
    x1: 29.5741,
    y1: 16.9997,
    x2: 8.4242,
    y2: 16.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_789_21167",
    x1: 21.7008,
    y1: 15.0487,
    x2: 2.36376,
    y2: -4.83596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_789_21167",
    x1: 6.37851,
    y1: 33.8502,
    x2: 15.0134,
    y2: 24.9709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google Play.369eee5adaaddea98a23239fa019cb8b.svg";
export { ForwardRef as ReactComponent };